import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import BasePtpForm from "../base-ptp-form";
import {PerFormaAPIService} from "src/app/services/pfapi.service";

@Component({
    selector: "app-goods-receipt",
    templateUrl: "./goods-receipt.component.html",
    styleUrls: ["./goods-receipt.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GoodsReceiptComponent extends BasePtpForm implements OnInit {
    constructor(
        api: PerFormaAPIService,
        private route: ActivatedRoute
    ) {
        super(api);
    }

    ModalOptions = {animation: false, backdropClass: "backdrop"};
    PO: any = {};
    NewRequest: any = {};
    POID;

    Refresh() {
        this.getData();
    }

    getData = () => {
        this.api.getApiPTPGetGoodsReceipt({poId: this.POID}).subscribe(data => {
            // Set scope purchase order.
            this.PO = data;
            // Set loading as false.
            this.Loading = false;

            // see if we need to scroll
            if (this.DoScroll && this.ScrollTo?.length > 0) {
                setTimeout(() => {
                    this.ScrollToElement(this.ScrollTo);
                }, 500);
            }
        });
    };

    ngOnInit(): void {
        window.addEventListener("message", event => {
            if (event?.data?.action === "SaveForm") {
                this.Update(() => {
                    window.parent.postMessage({...event.data, action: "LoadForm"});
                });
            }
        });

        // get the query params
        const params = new URL(window.location.toString()).searchParams;

        const show = params.get("show") ?? "";

        if (show != "") {
            this.DoScroll = true;
            this.ScrollTo = show;
        }

        this.route.queryParams.subscribe(f => {
            if (f.poid) {
                this.POID = f.poid;
                this.getData();
            }
        });
    }

    // Updates the PO request with the scope model.
    Update = (next?: () => void) => {
        this.Loading = true;
        this.api.postApiPTPUpdateGoodsReceipt(this.PO).subscribe(
            next ??
                (() => {
                    this.getData();
                    this.Success("Updated successfully");
                })
        );
    };

    MarkAllReceived = () => {
        if (this.PO && this.PO.LineItems && this.PO.LineItems.length > 0) {
            for (let i = 0; i < this.PO.LineItems.length; i++) {
                const item = this.PO.LineItems[i];
                item.Received = item.Quantity;
            }
        }
    };

    // Gets the total of all line items.
    GetLinesItemTotal = () => {
        let total = 0;
        if (this.PO && this.PO.LineItems && this.PO.LineItems.length > 0) {
            for (let i = 0; i < this.PO.LineItems.length; i++) {
                const item = this.PO.LineItems[i];
                total += item.Quantity * item.Price;
            }
        }
        return total.toFixed(2);
    };

    // Gets the total quantity of all line items.
    GetLinesItemQuantityTotal = () => {
        let total = 0;
        if (this.PO && this.PO.LineItems && this.PO.LineItems.length > 0) {
            for (let i = 0; i < this.PO.LineItems.length; i++) {
                const item = this.PO.LineItems[i];
                total += item.Quantity;
            }
        }
        return total.toFixed(2);
    };

    // Gets the total missing quantity of all line items.
    GetLinesItemMissingTotal = () => {
        let total = 0;
        if (this.PO && this.PO.LineItems && this.PO.LineItems.length > 0) {
            for (let i = 0; i < this.PO.LineItems.length; i++) {
                const item = this.PO.LineItems[i];
                total += item.Quantity - item.Received;
            }
        }
        return total.toFixed(2);
    };

    GetItemClass = item => {
        if (item.Quantity != item.Received) {
            return "alert alert-warning";
        }
        return "alert alert-success";
    };

    CheckAllItems = () => {
        if (!this.PO || !this.PO.LineItems) {
            return;
        }
        this.PO.LineItems.forEach(item => {
            item.Received = true;
        });
    };

    // Shows a success message.
    Success = message => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        window.parent.successAlert(message);
    };
}
